import { nsSelector, selector } from '../../../../../../utils/redux';

const activitiesSelector = nsSelector('production');

export const allActivities = activitiesSelector('allItemsList');
export const allTransports = activitiesSelector('allTransportsList');
export const versionList = activitiesSelector('versionList');
export const selectedIds = selector('production.allItemsList.selectedIds');
